import { inject, ref } from "vue";

import { FunderInfoPageFunderIdKey } from "@/helpers/symbols";
import { submitWithErrorHandling } from "@/helpers/vee-validate";
import { useAnalyticsStore } from "@/stores/analytics";

import { useUpdateFunderMutation } from "./queries/funders";

import type { IFunder } from "@/models/funders";
import type { SubmissionContext } from "vee-validate";

export const useFunderForm = () => {
  const { mutateAsync: updateFunder } = useUpdateFunderMutation();
  const { trackException } = useAnalyticsStore();
  const funderId = inject(FunderInfoPageFunderIdKey, ref(undefined));

  const submitUpdateFunder = async <TValues extends Partial<IFunder>>(
    values: TValues,
    actions: SubmissionContext<TValues>,
    onUpdate?: (updatedFunder: IFunder) => void
  ) => {
    if (!funderId.value) {
      return trackException(new Error("Funder ID is undefined "));
    }

    await submitWithErrorHandling(actions, async () => {
      const updatedFunder = await updateFunder({
        data: values,
        funderId: funderId.value!,
      });
      onUpdate?.(updatedFunder);
    });
  };

  return {
    submitUpdateFunder,
  };
};
